module.exports = __webpack_public_path__ + "static/calle03-b54e9a5c22c537849a52d4c6f21133e3.jpeg";